import Icon from "../Icon";

// El aviso flotante (esquina inferior derecha). El estado y su temporizador viven
// en App (showToast): esto solo lo pinta.

export default function Toast({ toast, setToast }) {
  return (
    <>
      {toast&&(
        <div className="toast" role={toast.type==="error"?"alert":"status"} aria-live={toast.type==="error"?"assertive":"polite"}
          style={{position:"fixed",bottom:22,right:22,zIndex:300,padding:"10px 16px",borderRadius:10,fontSize:12.5,fontWeight:600,boxShadow:"var(--shadow-lg)",fontFamily:"var(--font)",
          background:toast.type==="error"?"#fef2f2":toast.type==="warn"?"#fefce8":toast.type==="ok"?"#f0fdf4":"var(--surface)",
          color:toast.type==="error"?"#b91c1c":toast.type==="warn"?"#a16207":toast.type==="ok"?"#15803d":"var(--text)",
          border:`1px solid ${toast.type==="error"?"var(--red-line)":toast.type==="warn"?"var(--warn-line)":toast.type==="ok"?"var(--ok-line)":"var(--border)"}`,
          display:"flex",alignItems:"center",gap:8}}>
          <Icon name={toast.type==="ok"?"check-circle-fill":"exclamation-triangle-fill"} size={14} color={toast.type==="ok"?"#16a34a":toast.type==="error"?"#dc2626":"#a16207"}/>
          {toast.msg}
          {toast.veces>1&&(
            <span title={`Ha ocurrido ${toast.veces} veces`}
              style={{fontSize:11,fontWeight:800,padding:"1px 7px",borderRadius:20,background:"rgba(0,0,0,.09)"}}>
              ×{toast.veces}
            </span>
          )}
          {toast.type==="error"&&(
            <button onClick={()=>setToast(null)} aria-label="Cerrar aviso"
              style={{background:"none",border:"none",cursor:"pointer",padding:2,marginLeft:4,display:"flex"}}>
              <Icon name="x-lg" size={11} color="#b91c1c"/>
            </button>
          )}
        </div>
      )}
    </>
  );
}
